/** Settings sub-routes: `#/settings` and `#/settings/<section>`. */

export const SETTINGS_SECTIONS = Object.freeze([
  "account",
  "security",
  "creator",
  "preferences",
]);

export const DEFAULT_SETTINGS_SECTION = "account";

const LABELS = Object.freeze({
  account: "Account",
  security: "Security",
  creator: "Creator",
  preferences: "Preferences",
});

/**
 * @param {string} hashOrPath
 * @returns {string} one of SETTINGS_SECTIONS
 */
export function parseSettingsSection(hashOrPath) {
  const raw = String(hashOrPath || "")
    .trim()
    .replace(/^#\/?/, "")
    .replace(/^\/+/, "");
  const parts = raw.split("/").filter(Boolean);
  if (parts[0] !== "settings") {
    return DEFAULT_SETTINGS_SECTION;
  }
  const section = (parts[1] || DEFAULT_SETTINGS_SECTION).toLowerCase();
  if (SETTINGS_SECTIONS.includes(section)) return section;
  return DEFAULT_SETTINGS_SECTION;
}

/**
 * @param {string} section
 * @returns {string} location hash including leading `#`
 */
export function settingsHash(section) {
  const id = SETTINGS_SECTIONS.includes(section)
    ? section
    : DEFAULT_SETTINGS_SECTION;
  if (id === DEFAULT_SETTINGS_SECTION) return "#/settings";
  return `#/settings/${id}`;
}

/** @param {string} id */
export function settingsSectionLabel(id) {
  return LABELS[id] || id;
}
